<script setup>
import { useAttrs } from 'vue';

defineProps({
  buttonText: {
    type: String,
    default: '',
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  iconColor: {
    type: String,
    default: '',
  },
});

defineOptions({ inheritAttrs: false });

const attrs = useAttrs();
const getHoverAttrs = () =>
  Object.fromEntries(
    Object.entries(attrs).filter(([key]) =>
      ['onMouseenter', 'onMouseleave'].includes(key)
    )
  );
const getButtonAttrs = () =>
  Object.fromEntries(
    Object.entries(attrs).filter(
      ([key]) => !['onMouseenter', 'onMouseleave'].includes(key)
    )
  );
</script>

<template>
  <div
    v-bind="getHoverAttrs()"
    class="relative first:rounded-t-xl last:rounded-b-xl"
  >
    <button
      v-bind="getButtonAttrs()"
      class="relative inline-flex items-center justify-start w-full p-3 border-0 rounded-[inherit] h-11 hover:enabled:bg-n-alpha-2"
    >
      <div class="inline-flex items-center gap-3 overflow-hidden">
        <fluent-icon
          v-if="icon"
          :icon="icon"
          size="18"
          :style="{ color: iconColor }"
        />
        <span class="text-sm font-medium truncate text-n-slate-12">
          {{ buttonText }}
        </span>
        <span
          v-if="isActive"
          class="i-ri-check-line size-[18px] flex-shrink-0 text-n-slate-12"
        />
      </div>
    </button>
    <slot name="dropdown" />
  </div>
</template>
